var map = {
	"./1.png": 2787,
	"./Discovery.png": 2788,
	"./Health Squared.jpg": 2789,
	"./PPS.jpg": 2790,
	"./Sizwe.jpg": 2791,
	"./agility.png": 2792,
	"./bestmed.jpg": 2793,
	"./bidvest-small.png": 2794,
	"./bidvest.png": 2795,
	"./bonitas.jpg": 2796,
	"./compcare.jpg": 2797,
	"./curemed.png": 2798,
	"./fedhealth.jpg": 2799,
	"./fmi-small.png": 2800,
	"./fmi-small0.png": 2801,
	"./fmi.png": 2802,
	"./fmi0.png": 2803,
	"./hosmed - Copy.jpg": 2804,
	"./hosmed.jpg": 2805,
	"./keyhealth.png": 2806,
	"./liberty-small.jpg": 2807,
	"./liberty.png": 2808,
	"./madgap.png": 2809,
	"./medgap.png": 2810,
	"./medihelp.jpg": 743,
	"./medshield.png": 2811,
	"./momentum-small.jpg": 2812,
	"./momentum.png": 2813,
	"./momentumMed.png": 2814,
	"./old mutual.jpg": 2815,
	"./old mutual.png": 2816,
	"./oldmutual.png": 2817,
	"./pps.png": 2818,
	"./profmed.jpg": 2819,
	"./sanlam-small.png": 2820,
	"./sanlam.png": 2821,
	"./sirago.png": 2822,
	"./stratum.jpg": 2823,
	"./sureqoute1.png": 2824,
	"./sureqoute2.png": 2825,
	"./tra.svg": 2826,
	"./turnberry.png": 2827,
	"./zest.jpg": 2828
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo ^\.\/.*$
// module id = 424
// module chunks = 0